import type { SelectSmallOption } from '_atoms/SelectSmall';

export interface TableFooterLimit extends SelectSmallOption {
  value: number;
  label: number;
}

export const ITEM_PER_PAGE: TableFooterLimit[] = [
  { value: 30, label: 30 },
  { value: 50, label: 50 },
  { value: 70, label: 70 },
];
